import { buildRunIdParam } from 'src/common/helpers/GQLRequestsHelper/buildRunIdParam';

import { MobileSdkTestIssueTypesQueryVariables } from '../MobileSdkTestIssueTypes.generated';

export const buildMobileSdkTestIssueTypesQueryVariables = (
	testId: string
): MobileSdkTestIssueTypesQueryVariables => ({
	runId: buildRunIdParam(testId).runId
});
